import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const TagIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
      <path
        d="M6.6 5.3a1.8 1.8 0 100 3.601 1.8 1.8 0 000-3.6zm16.347 5.653L12.854.848A1.2 1.2 0 0012.002.5H1.2A1.2 1.2 0 000 1.7v10.802a1.2 1.2 0 00.348.852l10.105 10.093a3.6 3.6 0 005.09 0l7.404-7.345a3.6 3.6 0 000-5.089v-.06zm-1.692 3.385l-7.417 7.405a1.2 1.2 0 01-1.692 0L2.4 12.01V2.9h9.11l9.745 9.746a1.2 1.2 0 010 1.692z"
        fillRule="evenodd"
      />
    </svg>
  )
})
